export enum OwnershipType {
	Owned = 'Owned',
	Member = 'Member',
	Independent = 'Independent'
}